const testNames = ["SAT", "ACT", "IELTS", "TOEFL"];
export default testNames;
